exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1e-FC{margin:16px 8px;margin:1rem .5rem}._3i2NN{height:393px;width:191px}._1YnH1{margin:0 auto;margin-top:64px;margin-top:4rem}._1YnH1 h1{font-size:28.8px;font-size:1.8rem}._3lrjq{width:32px;width:2rem;height:280px;height:17.5rem;background:linear-gradient(90deg,rgba(43,45,52,0) 22%,rgba(43,45,52,.32) 71%,rgba(43,45,52,.4) 80%,rgba(43,45,52,.59));-webkit-filter:progid:dximagetransform.microsoft.gradient(startColorstr=\"#002b2d34\",endColorstr=\"#962b2d34\",GradientType=1);filter:progid:dximagetransform.microsoft.gradient(startColorstr=\"#002b2d34\",endColorstr=\"#962b2d34\",GradientType=1);position:absolute;z-index:10;right:0;pointer-events:none}::-webkit-scrollbar{display:none}._37xQP{display:none}._1TNlF{background:rgba(0,0,0,.6);border:none;margin-left:-28.8px;margin-left:-1.8rem;margin-right:-28.8px;margin-right:-1.8rem;outline:none;height:128px;height:8rem;width:64px;width:4rem;cursor:pointer}._1TNlF img{width:24px;width:1.5rem;cursor:pointer;opacity:.6}._1TNlF:hover img{opacity:1}", ""]);

// exports
exports.locals = {
	"main_container": "_1e-FC",
	"content": "_3i2NN",
	"title_container": "_1YnH1",
	"shadow": "_3lrjq",
	"arrowHide": "_37xQP",
	"arrow": "_1TNlF"
};